module.exports = {"share":{"rowsPerPage":"จำนวน","rangeSeparator":"จาก","noData":"ไม่มีข้อมูล"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/th/share.json
// module id = 551
// module chunks = 14